const getters = {
  keywords: state => state.user.keywords,
  permissions: state => state.user.permissions,
  status: state => state.user.status,
  cartNum: state => state.user.cartNum,
  info: state => state.user.info,
  isPC: state => state.user.isPC,
  phoneType: state => state.user.phoneType,
  categoryBanner: state => state.user.categoryBanner,
  yiBanToken: state => state.user.yiBanToken,
  yiBanUserInfo: state => {
    return JSON.parse(localStorage.getItem('yiBanUserInfo')) || state.user.yiBanUserInfo
  }
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js